<template>
    <div>
        <el-upload
            ref="uploadmodel"

            :class="['l-upload',disabled?'readonly':'']"
            action=""
            :http-request="uploadmodel"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :multiple="multiple"
            :limit="1"
            :on-error="handleError"
            accept=".xls,.xlsx"
            :on-exceed="handleExceed"
            :on-success="handlesuccess"
            :before-upload="handleBeforeUpload"
            :show-file-list="false"
            :file-list="fileList"
            :data="param"
            :readonly="readonly"
            :writeonly="writeonly"
            :list-type="listType"
            :disabled="disabled"
            >
            <div v-if="isTip" slot="tip" class="el-upload__tip">{{tipMsg}}</div>
            <template v-if="!disabled">                
                <el-button v-if="!readonly"  size="mini" type="primary" icon="el-icon-upload" >{{uplabel?uplabel:'导入'}}</el-button>
                <el-button slot="tip" v-if="!writeonly" style="margin-left:8px" size="mini" type="primary" icon="el-icon-download" @click="handleDownload(apiUrl, token)"  >{{downlabel?downlabel:'导出'}}</el-button>
            </template>
        </el-upload>
    </div>
</template>

<script>
export default {
    name:'l-uploadmodel',
    props: { 
        value:{},        
        disabled:{
            type:Boolean,
            default:false
        },        
        readonly:{
            type:Boolean,
            default:false
        },
        writeonly:{
            type:Boolean,
            default:false
        },
        limit:{
            type:Number,
            default:1
        },
        maxSize:String,
        sizeType:String,
        isTip:Boolean,
        listType:String,
        multiple:{
            type:Boolean,
            default:true
        },        
        uplabel: String,
        downlabel: String, 
        gridtable: String,
        keep: String,
        source: String,
        doing: String,
        error: String,
        context: String,
        eventCode: String,
        columns: {
            type:Array,
            default: ()=>{
            return []
        }},
    },
    watch: {
        value:{
            handler(val,oldVal){
                if(this.$validatenull(val)){
                    this.folderId = this.$uuid();
                    this.fileList = [];
                }
                else{
                    // 加载列表页
                    if((val != oldVal && !this.$validatenull(oldVal)) || val != this.folderId){
                        this.handleLoadFileList(val)
                    }
                }
            },
            immediate: true
        },
    },
    data () {
        return { 
            folderId:'',
            fileList:[],
            uploadFiles:[],
            loadingObj: null
        }
    },
    created () {
        this.folderId = this.$uuid()  
    },
    mounted () {
    },
    computed:{
        param(){
            return {
                folderId: this.value || this.folderId,
                maxSize: this.maxSize,
                sizeType: this.sizeType
            };
        },
        tipMsg(){
            return `只能上传不超过${this.maxSize || ''}${this.sizeType || ''}的${this.accept || ''}文件`
        },
    },
    methods:{
        async handleDownload(apiUrl, token){
            const api = window.$api.system.annexesFile 
            var mode = this.context || 'model';
            var formData = {}
            if(mode == 'model')
                formData["columns"] = this.columns
            var res = await api.download(this.folderId, mode, formData); //datatable
            var response = res.data;
            if(response.code != 200){
                this.$message.error(response.info)
                return;
            }else{
                var downloadUrl = `${apiUrl}system/download/${response.data}?token=${token}`;
                this.$downFile(downloadUrl)
            }
        },
        showLoading(show, text){
            if(show){
                    this.loadingObj = this.$loading({
                    lock: true,
                    text: text || '加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.4)'
                })
            }else{
                this.loadingObj && this.loadingObj.close()
            }
        },
        handleError(err/*, file, fileList*/){
            this.$message.error(err);
        },
        findComponentRefs(prop){
            var parent = this.$parent || this.$root;
            while (parent) {
                var $ref = parent.$refs[prop];
                if($ref)
                    return $ref;
                parent = parent.$parent;                
            }
            return null;
        },
        findViewer(){
            var parent = this.$parent || this.$root;
            while (parent) {
                if(parent.$options._componentTag == 'l-form-viewer'){
                    return parent;
                }
                parent = parent.$parent;                
            }
            return null;
        },
        getEventParams({  data }) {
            // 获取脚本参数
            const loginUser = this.loginInfo
            const params = {
                folderId: this.folderId,
                data: data,
                loginUser: loginUser,
                caller: this,
                formViewer: this.findViewer()
            }
            return params
        },
        getEvent(strEvent) {
            // 获取事件方法
            if (!this.$validatenull(strEvent)) {
                if (strEvent.indexOf('=>') != -1) {
                    // 表示是老版本，提示其修改为新的版本
                    console.warn('当前脚本不支持ES6语法，只支持ES5语法')
                    return { res: false, msg: '脚本没有更新为最新的版本！' }
                }
                else {
                    strEvent = `(function(){function fn(txChina) { var $p=txChina; var $this=$p.formViewer; ${strEvent}} return fn})()`
                    return this.$getFunction(strEvent)
                }
            }
            else {
                return { res: false, msg: '没设置脚本函数！' }
            }
        },
        async uploadCallback(fileData){
            const api = window.$api.system.annexesFile     
            this.showLoading(true, '正在导入....')
            fileData.columns = this.columns
            var res = await api.uploadData(fileData); //datatable
            var response = res.data;
            if( response.code == 200)
            {
                try
                {                    
                    var errors = response.data.errors;
                    if(errors && errors.length > 0){
                        throw String(errors)
                    }
                    var dtRows = response.data.result;
                    const myEvent = this.getEvent(this.eventCode)
                    var eventResult = false;
                    if (myEvent.res) {
                        eventResult = myEvent.fn(this.getEventParams({  data: dtRows}))
                    }
                    if(!eventResult && this.gridtable)
                    {                        
                        var gridtable = this.findComponentRefs( this.gridtable)
                        if(gridtable && gridtable.length > 0){
                            gridtable = gridtable[0];
                            var dataSource = gridtable.dataSource;
                            if(this.source == 'clear'){
                                dataSource.length = 0
                            }
                            for(var i = 0; i < dtRows.length; i++){
                                dataSource.push(dtRows[i])
                            }
                        }
                    }
                }
                catch(error)
                {
                    response.code = 400
                    response.info = error
                }                
            }
            this.showLoading(false)
            return res;
        },
        dispatch(componentName, eventName, params){
            var parent = this.$parent || this.$root;
            var name = parent.$options.componentName;
            // 从这里可以看出是找到对应的组件对象
            while (parent && (!name || name !== componentName)) {
                parent = parent.$parent;
                if (parent) {
                    name = parent.$options.componentName;
                }
            }
            if (parent) {
                parent.$emit.apply(parent, [eventName].concat(params));
             }
        },
        async handleLoadFileList(val){
            if(this.lr_getFileList){
                let data = await this.lr_getFileList(val)
                if(val == this.value){
                    this.fileList = data;
                }
                if(data.length == 0){
                    this.$emit('input','')
                }
            }
        },
        handlesuccess(response){
            this.uploadFiles.push(response)
            if(!this.value){
                this.$emit('input',response.folderId) //写值
                this.$emit('change',response) //触发change
                setTimeout(()=>{
                    this.dispatch('ElFormItem', 'chagne', response)
                })
            }
        },
        handleRemove(file) {
            if(file.response){
                this.lr_deleteFile && this.lr_deleteFile(file.response.fileId)
                this.uploadFiles.splice(this.uploadFiles.findIndex(t=>t.fileId == file.response.fileId),1)
            }

            if(file.id){
                this.lr_deleteFile && this.lr_deleteFile(file.id)
                this.fileList.splice(this.fileList.findIndex(t=>t.id == file.id),1)
            }

            if(this.uploadFiles.length == 0 && this.fileList.length == 0){
                this.$emit('input','')
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file) {
           if(!this.compareSize(file.size)){
                return true;
            }
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        
        handleBeforeUpload(file){
            if(!this.compareSize(file.size)){
                this.$message.warning('上传文件超出大小了');
                return false;
            }
        },
        compareSize(fileSize){
            if(this.maxSize && this.sizeType){
                let size = fileSize;
                switch(this.sizeType){
                    case 'GB':
                        size = 1024 * 1024 * 1024 * Number(this.maxSize);
                        break;
                    case 'MB':
                        size = 1024 * 1024 * Number(this.maxSize);
                        break;
                    case 'KB':
                        size = 1024 * Number(this.maxSize);
                        break;
                }
                if(size <  fileSize){
                    return false;
                }
            }
            return true
        },
        uploadmodel(option){
            if(this.lr_chunkedUpload){
                this.lr_chunkedUpload(option, this.uploadCallback)
            }
            else{
                const {file} = option
                option.onSuccess({
                    name:file.name
                })
            }
        }
    }
}
</script>
<style lang="less">
@import './index.less';
</style>
